import React, { memo } from 'react';
import {
  FormPageInputItemTextZipCodeWithoutHyphen,
  TextZipCodeWithoutHyphenInput,
  TextPropertyZipCodeWithoutHyphen,
} from 'shared';
import { FormFieldZipCodeInputItemProps } from './shared';

type Props = FormFieldZipCodeInputItemProps<
  TextPropertyZipCodeWithoutHyphen,
  FormPageInputItemTextZipCodeWithoutHyphen
> & {
  zipCode: FormPageInputItemTextZipCodeWithoutHyphen['zipCode'];
};

const ZIP_CODE_KEY: Extract<
  keyof FormPageInputItemTextZipCodeWithoutHyphen,
  'zipCode'
> = 'zipCode';

export const TextZipCodeWithoutHyphen: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    zipCode,
    onChange,
    onBlur,
    className,
    errorMessages,
    displayError,
    onAutoCompleteAddressButtonClick,
    reEnter,
  }) => {
    const { propertyId, inputFormat } = property;
    const { placeholder, searchSetting } = inputFormat;
    const handleChange = (
      zipCode: FormPageInputItemTextZipCodeWithoutHyphen['zipCode'],
    ) => {
      onChange(ZIP_CODE_KEY, zipCode);
    };
    const handleBlur = (
      zipCode: FormPageInputItemTextZipCodeWithoutHyphen['zipCode'],
    ) => {
      onBlur(ZIP_CODE_KEY, zipCode);
    };
    const handleClick = () => {
      onAutoCompleteAddressButtonClick(propertyId, `${zipCode ?? ''}`);
    };
    return (
      <TextZipCodeWithoutHyphenInput
        propertyId={propertyId}
        placeholder={reEnter ? '' : placeholder}
        zipCode={zipCode}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onChange={handleChange}
        onBlur={handleBlur}
        design={design}
        className={className}
        displayAutoCompleteAddressButton={searchSetting != null}
        autoCompleteAddressButtonLabel={searchSetting?.searchButtonLabel || ''}
        onAutoCompleteAddressButtonClick={handleClick}
      />
    );
  },
);
